module.exports = __webpack_public_path__ + "img/workshop2-m.c987de00.png";